import { postData } from "@/request/api";
import { useMutation } from "@tanstack/react-query";

export const usePropertySummary = () => {
  return useMutation({
    mutationFn: async (data: { slug: string; locale: "ar" | "en" }) => {
      const res = await postData("ai/property-summary", data);
      return res.data as { summary: string; locale: string };
    },
  });
};
